import { useState, useRef } from 'react';
import { gemsInfo } from './data/arrayElems';

const FormList = () => {
  const [selected, setSelected] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const dropDownRef = useRef(null);
  const toggleDropdown = () => setIsOpen((prev) => !prev);
  return (
    <div>
      <div className='container'>
        <div ref={dropDownRef} className='dropdown'>
          <button className='btnToggle' onClick={toggleDropdown} type='button'>
            {selected ? (
              <div className='selectedItem'>
                <span>{selected.title}</span>
              </div>
            ) : (
              'Choose gem'
            )}
          </button>
          {isOpen && (
            <ul className='dropdownMenu' role='listbox'>
              {gemsInfo.map((gem) => (
                <li
                  key={gem.id}
                  role='option'
                  onClick={() => {
                    setSelected(gem);
                    setIsOpen(false);
                  }}
                >
                  <div className=''>{gem.title}</div>
                </li>
              ))}
            </ul>
          )}
        </div>
        {selected && !isOpen && (
          <div className='details'>
            <img src={selected.image} alt='-' />
          </div>
        )}
      </div>
    </div>
  );
};

export default FormList;
